/* eslint-disable prettier/prettier */
export const badTlds: string[] = [
'mil',
'gov'
]